export type ReviewTimeUnit = 'minutes' | 'hours' | 'days' | 'weeks' | 'months';

export type ReviewTime = { unit: ReviewTimeUnit; count: number };

const MINUTE_MS = 60 * 1000;
const MINUTES_PER_HOUR = 60;
const HOURS_PER_DAY = 24;
const DAYS_PER_WEEK = 7;
const DAYS_PER_MONTH = 30;

export const getReviewTime = (nextReviewDate: string, now = new Date()): ReviewTime | null => {
  const reviewTimestamp = new Date(nextReviewDate).getTime();
  if (Number.isNaN(reviewTimestamp)) return null;

  const minutes = Math.max(1, Math.ceil((reviewTimestamp - now.getTime()) / MINUTE_MS));
  if (minutes < MINUTES_PER_HOUR) return { unit: 'minutes', count: minutes };

  const hours = Math.floor(minutes / MINUTES_PER_HOUR);
  if (hours < HOURS_PER_DAY) return { unit: 'hours', count: hours };

  const days = Math.floor(hours / HOURS_PER_DAY);
  if (days < DAYS_PER_WEEK) return { unit: 'days', count: days };
  if (days < DAYS_PER_MONTH) return { unit: 'weeks', count: Math.floor(days / DAYS_PER_WEEK) };

  return { unit: 'months', count: Math.floor(days / DAYS_PER_MONTH) };
};
